var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "loading-area" },
        [
          _vm.loading
            ? _c("v-btn", {
                staticClass: "loading-button",
                attrs: { fab: "", loading: _vm.loading, elevation: "2" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "v-card",
            {
              staticClass: "mx-auto",
              attrs: { "max-width": "1440", outlined: "", elevation: "0" }
            },
            [
              _c("card-header", {
                attrs: { diaryType: "menu" },
                on: { studentsLoaded: _vm.reloadStudents }
              }),
              _vm._v(" "),
              _c("menu-diary", {
                staticClass: "height-area",
                attrs: { classId: _vm.classId, students: _vm.students },
                on: { updatedStudent: _vm.catchChanges }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aecf9c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aecf9c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/menuForm.vue
// module id = 293
// module chunks = 1